<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" @close="$emit('update:visible',false)">
 <div class="view">
    <div class="content">
      <div class="condition">
        <div class="other_wrap">
          <el-button type="primary" @click="addspecification">新增</el-button>
        </div>
      </div>
      <div class="table_wrap">
        <el-table :data="tableData" style="width: 100%" highlight-current-row
         @current-change="handleCurrentChange">
          <el-table-column prop="name" label="规格名称"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button @click="edit(scope.row.id)" type="text" size="small">编辑</el-button>
              <el-button @click="del(scope.row.id)" type="text" size="small">删除</el-button>
              <el-button @click="make(scope.row.id)" type="text" size="small">定制规格</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pag_wrap">
          <el-pagination
            background
            @current-change="pageIndexChange"
            :page-size="page.pagesize"
            :current-page="page.pageindex"
            layout="total, prev, pager, next"
            :total="page.total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <customSpecificationDialog
      :id="id"
      :visible.sync="specificationdialog"
      v-if="specificationdialog"
      @specificationsuccess="specificationsuccess"
    ></customSpecificationDialog>
       <goodsCustomMakeListDialog
      :id="id"
      :visible.sync="customMakeListShow"
      v-if="customMakeListShow"
      :customMakeId="customMakeId"
      @specificationsuccess="specificationsuccess"
    ></goodsCustomMakeListDialog>
  </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="save('form')">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import customSpecificationDialog from "@/components/dialog/customSpecificationDialog.vue";
import goodsCustomMakeListDialog from '@/components/dialog/goodsCustomMakeListDialog.vue';
import api from "@/api.js";
import { pagination } from "@/util/util.js";
export default {
  name: "goodsSelectSpecificationDialog",
  props: ["visible", "id"],
  components: {
    customSpecificationDialog,
    goodsCustomMakeListDialog
  },
  watch: {
    visible() {
      this.dialogVisible = this.visible;
    }
  },
  data() {
    return {
      customMakeListShow:false,
      dialogVisible: this.visible,
      title: "选择定制规格",
      formdata: {
        name: ""
      },
      tableData: [],
      del_spec: [],
      del_item: [],
      lock: true,
      rules: {
        name: [{ required: true, message: "请输入类目名称", trigger: "blur" }]
      },
      page: {
        pageindex: pagination.pageIndex,
        pagesize: pagination.pageSize,
        total: pagination.total
      },
      specificationdialog: false,
      currentRow:'',
    };
  },
  created() {
    // if (this.id) {
    //   this.title = "编辑类目";
    //   this.queryspecification();
    // }
    this.init();

  },
  methods: {
     save(){
      if(!this.currentRow){
        this.$message.warning('请选择规格');
        return
      }
      this.$emit("handleSelectCustomList",this.currentRow);
      this.dialogVisible = false;
    },
    handleCurrentChange(val) {
      this.currentRow = val;
      console.log(val,'handleCurrentChange')
    },
   make(id) {
      this.customMakeId = id
			this.customMakeListShow = true
		},
    //初始化请求
    init() {
      this.page.pageindex = 1;
      this.querylist();
    },
    //查询列表
    querylist() {
      let params = {
        page: this.page.pageindex
      };
      this.axios
        .post(api.make_spe_list, params)
        .then(response => {
          if (response.data.code == 0) {
            this.tableData = response.data.list;
            this.page.total = response.data.all_page;
          } else {
            this.page.total = 0;
          }
        })
        .catch(() => {});
    },
    // 分页
    pageIndexChange(pageindex) {
      this.page.pageindex = pageindex;
      this.querylist();
    },
    // 添加类目
    addspecification() {
      this.id = "";
      this.specificationdialog = true;
    },
    // 添加类目成功回调
    specificationsuccess() {
      this.querylist();
    },
    // 编辑
    edit(id) {
      this.id = id;
      this.specificationdialog = true;
    },
    del(id) {
      // this.disableddel(id, 0);
      this.$confirm("是否删除?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning"
					})
					.then(() => {
						this.submitdel(id);
					})
					.catch(() => {
						this.$message({
							type: "warning",
							message: "已取消删除"
						});
					});
    },
    // 是否可以删除
    disableddel(id, type) {
      let params = {
        id: id,
        type: type
      };
      this.axios
        .post(api.goods_attr_delete_check, params)
        .then(response => {
          if (response.data.code == 0) {
            this.submitdel(id);
          } else {
          }
        })
        .catch(() => {});
    },
    // 删除
    submitdel(id) {
      let params = {
        id: id
      };
      this.axios
        .post(api.make_spe_del, params)
        .then(response => {
          if (response.data.code == 0) {
            this.$message({
              message: "删除成功",
              type: "success"
            });
            this.init();
          } else {
          }
        })
        .catch(() => {});
    }
  }
};
</script>

